import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDateRanges } from '../../../shared/lib/hooks/UseDateRanges'
import { OrganicResultsFilterInterface } from './types/OrganicResultsFilter.interface'
import { RootState } from '../../../app/store/Store'
import { IPagination } from '../../../shared/types/Pagination.interface'
import { IOption } from '../../../shared/components/forms/search-input/BpSearchInput'

type OrganicResultsState = {
  filters: OrganicResultsFilterInterface
  pagination: IPagination
  project: IOption & { is_demo: boolean; has_paid_links: boolean; has_seo_links: boolean }
  country?: IOption & {
    keywords_state?: 'active' | 'deleted' | 'never'
  }
}

const dateRanges = useDateRanges()

const organicResultsSlice = createSlice({
  name: 'organic',
  initialState: {
    filters: {
      dateRange: dateRanges.month,
      show_affiliates: false,
      show_hidden: false,
      has_brand: false,
      reversed_filters: '',
    },
    pagination: {
      current: 1,
      pageSize: 10,
      total: 1,
    },
    project: {
      is_demo: false,
      has_paid_links: true,
      has_seo_links: true,
    },
  } as OrganicResultsState,
  reducers: {
    setOrganicResultsFilter: (
      state: OrganicResultsState,
      action: PayloadAction<OrganicResultsFilterInterface>,
    ) => {
      state.filters = {
        ...state.filters,
        ...{ ...action.payload, has_brand: state.filters.has_brand },
      }
    },
    setOrganicResultsPagination: (
      state: OrganicResultsState,
      action: PayloadAction<IPagination>,
    ) => {
      state.pagination = action.payload
    },
    setHasBrand: (state: OrganicResultsState, action: PayloadAction<boolean>) => {
      state.filters = { ...state.filters, has_brand: action.payload }
    },
    setProject: (
      state: OrganicResultsState,
      action: PayloadAction<
        IOption & { is_demo: boolean; has_paid_links: boolean; has_seo_links: boolean }
      >,
    ) => {
      state.project = action.payload
    },
    setCountry: (
      state: OrganicResultsState,
      action: PayloadAction<
        | (IOption & {
            keywords_state?: 'active' | 'deleted' | 'never'
          })
        | undefined
      >,
    ) => {
      state.country = action.payload
    },
  },
})

export const {
  setOrganicResultsFilter,
  setOrganicResultsPagination,
  setHasBrand,
  setProject,
  setCountry,
} = organicResultsSlice.actions

export const selectOrganicResultsFilters = (state: RootState) => state.root.organicResults.filters
export const selectOrganicResultsPagination = (state: RootState) =>
  state.root.organicResults.pagination
export const selectProject = (state: RootState) => state.root.organicResults.project
export const selectCountry = (state: RootState) => state.root.organicResults.country

export default organicResultsSlice.reducer
